module.exports = __webpack_public_path__ + "static/media/front_phones_2.f91597bb.png";